import { fixPaginationLayout } from './fix-pagination'
import { setCMSBarWidth } from './cms-bar-width'
import { appendVersions } from './site-common'


document.addEventListener('DOMContentLoaded', () => {
    fixPaginationLayout()

    /* Menu control */
    const body = document.querySelector('body')
    const toggleMenu = document.getElementById('toggleMenu')
    const openMenu = document.getElementById('openMenu')
    const closeMenu = document.getElementById('closeMenu')

    function menu(element, add) {
        toggleMenu.addEventListener('click', function() {
            element.classList.toggle(add)
        })
    }

    menu(body, 'show-body')
    menu(openMenu, 'hide-icon')
    menu(closeMenu, 'show-icon')

    /* clone submenu */
    const activeSubmenu = document.querySelector('.active-submenu')
    if (activeSubmenu) {
        const clone = activeSubmenu.cloneNode(true)
        document.getElementById('clon-submenu').appendChild(clone)
    }

    /* add class active-submenu */
    const menuWrapper = document.getElementsByClassName('menu-wrapper')
    if (menuWrapper.length > 0) {
        const container = document.querySelector('.container')
        if (container) {
            container.classList.add('active-submenu')
        }
    }

    /* aldyryn form add actually time zone and date */
    const timeZoneClass = document.querySelector('.time-zone')
    const actuallyTimeClass = document.querySelector('.actually-time')
    if (timeZoneClass && actuallyTimeClass) {
        timeZoneClass.value = Intl.DateTimeFormat().resolvedOptions().timeZone
        const today = new Date()
        actuallyTimeClass.value = `${today.toLocaleDateString()} ${today.toLocaleTimeString()}`
    }

    const structure = document.querySelector('.cms-toolbar-item-cms-mode-switcher > a:not(.cms-btn-disabled)')
    if (structure) {
        structure.addEventListener('click', () => {setTimeout(setCMSBarWidth, 1000)}, true)
    }

    appendVersions(document.querySelector('.cms-toolbar-item-logo a'))
})
